var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-body crud-item-grid" }, [
    _c("div", { staticClass: "row", staticStyle: { "margin-top": "15px" } }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.errors.first("kitEmbalagem"),
                expression: "errors.first('kitEmbalagem')",
              },
            ],
            staticClass: "form-group",
          },
          [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "kitEmbalagem" } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t(
                        "__.Components.parent.manipulacao.itemTable_vue_html.kitEmbalagem"
                      )
                    ) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("combo-component", {
              attrs: {
                id: "kitEmbalagem",
                name: "kitEmbalagem",
                value: _vm.manipulacaoContext.manipulacao.kitEmbalagemId,
                data: _vm.manipulacaoContext.kitEmbalagensOptions,
                refresh: _vm.loadKitEmbalagem,
                disabled: _vm.manipulacaoContext.isDesabilitado,
              },
              on: { input: _vm.onChangeKitEmbalagem },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-condensed table-striped" }, [
      _c("thead", [
        _c("tr", [
          _c("th", [
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm._l(_vm.theader, function (nameHeader, nameIndex) {
                  return [
                    _c(
                      "div",
                      {
                        key: nameIndex,
                        class: "col-sm-" + _vm.theaderColSpan[nameIndex],
                        staticStyle: { "padding-left": "10px !important" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(nameHeader) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.manipulacaoContext.embalagens, function (item, index) {
          return _c("tr", { key: index }, [
            _c(
              "td",
              { staticClass: "large-column" },
              [
                [
                  _c(
                    "keep-alive",
                    [
                      _c("manipulacao-item-component", {
                        ref: "manipulacaoItemComponent",
                        refInFor: true,
                        staticClass: "ignorePrint",
                        attrs: {
                          index: index,
                          uuid: _vm.uuid,
                          itemModel: item,
                          itemType: 1,
                          setorId: _vm.setorId,
                        },
                        on: {
                          onRefazerHeader: _vm.onRefazerHeader,
                          onAlterarVolumeCapsula: _vm.onAlterarVolumeCapsula,
                          onCorCapsulaChange: _vm.onCorCapsulaChange,
                          onConsolidado: _vm.onConsolidado,
                        },
                      }),
                    ],
                    1
                  ),
                ],
              ],
              2
            ),
            _vm._v(" "),
            !_vm.manipulacaoContext.isDesabilitado
              ? _c("td", { staticClass: "option-column" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#", title: _vm.$t("__.Crud.excluir") },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.removeItem(index)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-times",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        })
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }